module.exports = __webpack_public_path__ + "static/media/2.982e87c6.jpg";